import FarloUiCrm from './../../vendors/farlo-ui-crm';

const farloUiSignupForms = {};

export function farloUiCrmSignup(input) {
    if (!input) {
        console.warn("farloUiCrmSignup called with a falsy value");
        return;
    }

    let crmId = null;
    let isEvent = false;

    if (typeof input === 'string') {
        crmId = input;
        // console.log("Received CRM id as string:", crmId);
    } 
    else if (typeof input === 'object') {
        if (input.target !== undefined && input.target !== null) {
            isEvent = true;
            crmId = input.target.dataset.crmButtonFor;
            if (!crmId || crmId.trim() === "") {
                console.warn("No CRM id found on the clicked element.");
                return;
            }
            // console.log("Event CRM id:", crmId);
        } 
        else if (input.id !== undefined) {
            crmId = input.id;
            if (!crmId || crmId.trim() === "") {
                console.warn("Empty CRM id passed to farloUiCrmSignup.");
                return;
            }
            // console.log("Direct CRM id:", crmId);
        } else {
            console.warn("Cannot determine CRM id from input object.", input);
            return;
        }
    } 
    else {
        console.warn("Unsupported type passed to farloUiCrmSignup:", input);
        return;
    }

    if (!crmId || crmId.trim() === "") {
        console.warn("Empty CRM id; aborting farloUiCrmSignup.");
        return;
    }

    if (!farloUiSignupForms[crmId]) {
        farloUiSignupForms[crmId] = new FarloUiCrm(crmId);
       //  console.log("Created instance for:", crmId, farloUiSignupForms[crmId]);
    }

    if (isEvent) {
        // console.log("Toggling form for:", crmId);
        farloUiSignupForms[crmId].toggleForm();
    }
}
